import { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../../api/auth.api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setIsLoading(true);

    if (!email) {
      setError('Por favor ingresa tu correo electrónico');
      setIsLoading(false);
      return;
    }

    try {
      const response = await forgotPassword(email);
      setSuccess(response.message);
      setEmail('');
    } catch (err: unknown) {
      if (err && typeof err === 'object' && 'response' in err) {
         const axiosError = err as { response?: { data?: { message?: string } } };
         setError(axiosError.response?.data?.message || 'Error al solicitar la recuperación');
      } else {
        setError('Error de conexión. Inténtalo más tarde.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-teal-500 rounded-2xl mb-4">
              <i className="ri-key-2-line text-3xl text-white"></i>
            </div>
            <h1 className="text-2xl font-bold text-slate-800 mb-2">
              Recuperar Contraseña
            </h1>
            <p className="text-slate-500 text-sm">
              Ingresa tu correo electrónico y te enviaremos las instrucciones.
            </p>
          </div>

          {success && (
            <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-xl">
              <div className="flex items-center gap-2">
                <i className="ri-check-line text-green-600"></i>
                <p className="text-sm text-green-600">{success}</p>
              </div>
            </div>
          )}

          {error && (
            <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl">
              <div className="flex items-center gap-2">
                <i className="ri-error-warning-line text-red-600"></i>
                <p className="text-sm text-red-600">{error}</p>
              </div>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">
                Correo electrónico
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i className="ri-mail-line text-slate-400"></i>
                </div>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition text-sm"
                  placeholder="ejemplo@correo.com"
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-teal-500 hover:bg-teal-600 disabled:bg-teal-300 text-white font-medium py-3 rounded-xl transition duration-200 shadow-lg shadow-teal-500/30 whitespace-nowrap flex items-center justify-center gap-2"
            >
              {isLoading ? (
                <>
                  <i className="ri-loader-4-line animate-spin"></i>
                  Enviando...
                </>
              ) : (
                'Enviar Instrucciones'
              )}
            </button>

            <div className="text-center pt-2">
                <Link to="/login" className="text-sm text-teal-600 hover:text-teal-700 font-medium flex items-center justify-center gap-1">
                    <i className="ri-arrow-left-line"></i>
                    Volver al inicio de sesión
                </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
